import React from 'react'
import { Route, Switch, useParams } from 'react-router-dom'
import { url2section } from 'ion-sections'
import loadable from '@loadable/component'
import { DefaultSectionPageSkeletonWrapper, ArticlePageSkeleton } from '../components/Skeletons'

const DefaultSectionPage = loadable(() => import('../pages/DefaultSectionPage'), {
  fallback: <DefaultSectionPageSkeletonWrapper />
})
// TODO
const OpinionSectionPage = loadable(() => import('../pages/OpinionSectionPage'), {
  fallback: <DefaultSectionPageSkeletonWrapper />
})
const TagPage  = loadable(() => import('../pages/TagPage'))
const Article = loadable(() => import('../pages/Article'), {
  fallback: <ArticlePageSkeleton />
})

const RenderArticle = (props) => {
  const { contentKey } = useParams()
  return <Article {...props} contentKey={contentKey} />
}

const Opinion = (props) => (
  <Switch>
    <Route exact path='/opinion' render={() => (
      <OpinionSectionPage {...props} isPage0={props.isPage0}
        section='opinion'
        mostReadSection='news'
        relatedSections={[{ id: 'news/opinion', label: 'News' }, { id: 'news/politics/opinion', label: 'Politics' }, { id: 'lifestyle/opinion', label: 'Lifestyle' }, { id: 'business-report/opinion', label: 'Business' }, { id: 'sport/opinion', label: 'Sport' }, { id: 'opinion/letters' }]}
        title='Opinion, Analysis & Commentary | IOL News'
        description='Read opinion pieces and commentary from South Africa, Africa and International influencers and thought leaders. Find in-depth analysis on current events and news.'
      />
    )} />
    <Route exact path='/opinion/letters' render={() => (
      <DefaultSectionPage {...props} isPage0={props.isPage0}
        section='opinion/letters'
        mostReadSection='news'
        relatedSections={[{ id: 'news/opinion', label: 'Opinion' }]}
        title='Letters | IOL News'
        description='Letters to the Editor'
      />
    )} />
    <Route path={'/opinion/:section([a-zA-Z0-9-/]+)/:title*([-])*:contentKey([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})'} exact render={() => (
      <RenderArticle {...props} />
    )} />
    <Route path={'/opinion/:title*([-])*:contentKey([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})'} exact render={() => (
      <RenderArticle {...props} />
    )} />
    <Route path={'/opinion/:section([a-zA-Z0-9-/]+)/:title*([-])*:contentKey([0-9]{5,})'} exact render={() => (
      <RenderArticle {...props} />
    )} />
    <Route path={'/opinion/:title*([-])*:contentKey([0-9]{5,})'} exact render={() => (
      <RenderArticle {...props} />
    )} />
    <Route path={'/opinion/:section([a-zA-Z0-9-/]+)'} exact render={() => (
      <TagPage {...props}
        section={url2section(props.location.pathname)}
        url={props.location.pathname}
      />
    )} />
  </Switch>
)

export default Opinion
